<template>
  <div class="homeForum HomeContainer">
    <div class="leftContainer">
      <div class="leftInnerContainer">
        <div class="title" :class="{ active: activeTab == 'all' }">
          <el-image
            :src="GetResourceUrl('forum/icon-forum.svg')"
          ></el-image>
          {{l("论坛")}}
        </div>
        <div class="tabs">
          <div
            class="tab"
            :class="{ active: activeTab == 'all' }"
            @click="clickActiveTab('all')"
          >
            <el-image
              v-show="activeTab == 'all'"
              :src="GetResourceUrl('forum/icon-all-active.svg')"
            ></el-image>
            <el-image
              v-show="activeTab != 'all'"
              :src="GetResourceUrl('forum/icon-all.svg')"
            ></el-image>
            <span>{{l("全部贴子")}}</span>
          </div>
          <div
            class="tab"
            :class="{ active: activeTab == 'post' && !$route.query.user_id }"
            @click="clickActiveTab('post')"
          >
            <el-image
              v-show="activeTab == 'post' && !$route.query.user_id"
              :src="GetResourceUrl('forum/icon-post-active.svg')"
            ></el-image>
            <el-image
              v-show="activeTab != 'post' || $route.query.user_id"
              :src="GetResourceUrl('forum/icon-post.svg')"
            ></el-image>
            <span>{{l("我的发帖")}}</span>
          </div>
          <div
            class="tab"
            :class="{ active: activeTab == 'with' }"
            @click="clickActiveTab('with')"
          >
            <el-image
              v-show="activeTab == 'with'"
              :src="GetResourceUrl('forum/icon-with-active.svg')"
            ></el-image>
            <el-image
              v-show="activeTab != 'with'"
              :src="GetResourceUrl('forum/icon-with.svg')"
            ></el-image>
            <span>
              {{l("与我相关")}}
              <div v-if="$store.state.unread_count.forum_discuss" class="count">
                {{ $store.state.unread_count.forum_discuss }}
              </div>
            </span>
          </div>
          <div
            class="tab"
            :class="{ active: activeTab == 'discuss' }"
            @click="clickActiveTab('discuss')"
          >
            <el-image
              v-show="activeTab == 'discuss'"
              :src="GetResourceUrl('forum/icon-discuss-active.svg')"
            ></el-image>
            <el-image
              v-show="activeTab != 'discuss'"
              :src="GetResourceUrl('forum/icon-discuss.svg')"
            ></el-image>
            <span>{{l("我的参与")}}</span>
          </div>
        </div>
        <div class="tagTitle">{{l("话题分类")}}</div>
        <div class="tags">
          <div
            v-for="tag of $store.state.basicInfo.tagList.forum"
            :key="tag.id"
            class="tag"
            :class="{ active: activeTag == tag.id }"
            @click="clickActiveTag(tag.id)"
          >
            {{ tag.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="midContainer">
      <template v-if="$route.name == 'forum'">
        <div
          v-if="activeTab == 'all' || activeTag"
          key="publishContainer"
          class="publishContainer"
        >
          <ForumPublish @submitDialog="GetTableList(true)" />
        </div>

        <ForumUserInfo
          v-else-if="
            activeTab == 'post' || activeTab == 'with' || activeTab == 'discuss'
          "
        />

        <ForumList
          :key="activeTab + activeTag"
          :content="SearchData.content"
          ref="ForumList"
        />
      </template>

      <template v-else-if="$route.name == 'forum_detail'">
        <ForumDetail key="ForumDetail" ref="ForumDetail" />
      </template>
    </div>
    <div class="rightContainer">
      <RecommendQuotationRightBar class="rightInnerContainer" />
    </div>
  </div>
</template>

<script>
import RecommendQuotationRightBar from "@/components/layout/RecommendQuotationRightBar";
import ForumList from "./ForumList.vue";
import ForumDetail from "./ForumDetail.vue";
import ForumPublish from "./ForumPublish.vue";
import ForumUserInfo from "./ForumUserInfo.vue";

export default {
  name: "HomeForum",
  components: {
    RecommendQuotationRightBar,
    ForumList,
    ForumDetail,
    ForumPublish,
    ForumUserInfo,
  },
  data() {
    return {
      activeTab: null,
      activeTag: null,
      user_info: {},
      SearchData: {
        content: this.$store.state.headerFilter,
      },
    };
  },
  created() {
    //forum / forum_detail
    if (this.$route.name == "forum") {
      if (this.$route.query.tab) {
        this.activeTab = this.$route.query.tab;
      } else if (this.$route.query.tag_id) {
        this.activeTag = Number(this.$route.query.tag_id);
      } else {
        this.activeTab = "all";
      }
    }
  },
  mounted() {
    this.$EventBus.$on("headerSearch", ({ filterText }) => {
      if (this.activeTab == "all" || this.activeTag) {
        this.SearchData.content = filterText;
        this.$nextTick(() => {
          //等待父组件SearchData.content传给子组件
          this.GetTableList(true);
        });
      } else {
        this.$router.push("/home/forum?tab=all");
      }
    });
  },
  beforeDestroy() {
    this.$EventBus.$off("headerSearch");
  },
  methods: {
    clickActiveTab(tab) {
      // this.activeTab = tab;
      // this.activeTag = null;
      this.$router.push({ name: "forum", query: { tab } });
    },
    clickActiveTag(tag_id) {
      // this.activeTag = tag;
      // this.activeTab = "";
      this.$router.push({ name: "forum", query: { tag_id } });
    },

    GetTableList(clearList, fakeAppCursor) {
      this.$refs.ForumList.GetTableList(clearList, fakeAppCursor);
    },
  },
};
</script>


<style scoped lang="scss">
.homeForum {
  margin-top: 15px;
  display: flex;

  .leftContainer {
    flex-shrink: 0;
    width: 190px;
    background: #fff;
    margin-right: 10px;
  }
  .midContainer {
    margin-right: 10px;
    flex-grow: 1;
    .publishContainer {
      width: 100%;
      min-height: 156px;
      background: #fff;
      border-radius: 4px;
      padding: 25px 20px 0;
      box-sizing: border-box;
      margin-bottom: 10px;
    }

    .more {
      text-align: center;
      height: 60px;
      color: #666;
      margin-top: 10px;
      background: #fff;
      span {
        line-height: 60px;
        font-size: 16px;
        cursor: pointer;
      }
      i {
        line-height: 60px;
        font-size: 24px;
      }
    }
  }
  .rightContainer {
    flex-shrink: 0;
    .rightInnerContainer {
      position: sticky;
      top: calc(100vh - 1600px);
      // top: 0;
      // min-height:100vh;
      // max-height: 400px;
      // overflow: auto;
    }
  }
}

.leftInnerContainer {
  position: sticky;
  top: 0;
  box-sizing: border-box;
  padding: 25px 20px;

  max-height: 100vh;
  overflow: auto;
  .title {
    font-size: 16px;
    box-sizing: border-box;
    padding-left: 25px;
    position: relative;
    display: flex;
    align-items: center;
    font-weight: bold;

    .el-image {
      width: 18px;
      height: 18px;
      position: absolute;
      left: -5px;
    }
  }
  .tabs {
    box-sizing: border-box;
    border-bottom: 1px solid $borderPlainColor;
    padding-bottom: 30px;
    .tab {
      display: flex;
      align-items: center;
      cursor: pointer;
      box-sizing: border-box;
      padding-left: 25px;
      margin-top: 20px;

      &.active {
        color: $warningColor;
      }

      .el-image {
        width: 15px;
        height: 14px;
      }
      span {
        margin-left: 26px;
        position: relative;
        .count {
          position: absolute;
          padding: 0px 6px;
          background: $dangerColor;
          color: #fff;
          font-size: 12px;
          text-align: center;
          border-radius: 10px;
          right: -20px;
          top: -8px;
          // transform: scale(0.8);
        }
      }
    }
  }
  .tagTitle {
    margin-top: 30px;
    padding-left: 25px;
    font-weight: bold;
  }
  .tags {
    padding-left: 25px;
    .tag {
      margin-top: 20px;
      display: flex;
      align-items: center;
      margin-left: 6px;
      cursor: pointer;
      &:before {
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #999;
        margin-right: 25px;
      }
      &.active {
        color: $warningColor;
        &:before {
          background: $warningColor;
        }
      }
    }
  }
}

.publishContainer {
  width: 100%;
  min-height: 156px;
  background: #fff;
  border-radius: 4px;
  padding: 25px 20px 0;
  box-sizing: border-box;
  .textarea {
  }

  .operationPanel {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    box-sizing: border-box;
    padding-bottom: 12px;
    .btnList {
      flex-shrink: 0;
      .el-select {
        width: 120px;
      }
      /deep/.el-input__inner {
        border: none;
        font-size: 14px;
        color: #999;
        text-align: right;
      }
    }
  }
}
</style>

